import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { isMobile, optional, prefersReducedMotion, qs } from '@/lib/dom'

/**
 * 10TH CONTENTS の横スクロール。
 * PC ではラッパーをピン留めし、縦スクロール量を `.side-scroll-list` の横移動に変換する。
 * SP は CSS 側の overflow-x に任せて何もしない。
 */
export function initSideScroll(): ScrollTrigger | null {
  const wrapper = optional('.side-scroll-list-wrapper')
  const list = qs<HTMLElement>('.side-scroll-list', wrapper ?? document)
  if (!wrapper || !list) return null
  if (isMobile() || prefersReducedMotion()) return null

  const overflow = (): number => Math.max(0, list.scrollWidth - window.innerWidth)
  if (overflow() === 0) return null

  const tween = gsap.to(list, {
    x: () => -overflow(),
    ease: 'none',
    scrollTrigger: {
      trigger: wrapper,
      start: 'top top',
      end: () => `+=${overflow()}`,
      pin: true,
      scrub: 1,
      anticipatePin: 1,
      invalidateOnRefresh: true,
    },
  })

  return tween.scrollTrigger ?? null
}
